export default "__VITE_ASSET__BXwnsjhj__"